export function Splashscreen() {
  return null;
}
